import React, { memo, useEffect, useMemo, useRef, useState } from 'react';
import Typography from "@material-ui/core/Typography";
import { Button } from "@material-ui/core";
import { themeButtons } from "../../../css/themeButtons";
import { useHistory } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import CloseRoundedIcon from "@material-ui/icons/CloseRounded";
import RoomPhotoContainer from "../../ObjectRoomEdit/RoomPhoto/RoomPhotoContainer";
import { RenderRoomAboutMain } from "../../ObjectRoomEdit/ObjectRoomEdit";
import { useQuery } from "../../common/CustomHook/useQuery";


const FastRoomEdit = memo((props) => {
  const [unsavedPhotos, toggleUnsavedPhotos] = useState(false);
  const [unsavedMainInfo, toggleUnsavedMainInfo] = useState(false);
  const [targetRedirectLink, setTargetRedirectLink] = useState(false)
  const history = useHistory()

  const {
    getRoomById, roomMain, roomIdByProps, getTypeList,
    typesList, clearRoom, objectId, country, updateRoom, addRoom,
    roomPhotoApprovedToDB, getRoomsList, goPage,
  } = props

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [])

  useEffect(() => {
    if (history.action === "POP") {
      goPage("rooms")
    }
  }, [goPage, history])

  const query = useQuery();
  const roomId = query.get("room")


  //реф форм основной информации о номере
  const objectAboutMainRef = useRef();

  const [presavePage, setPresavePage] = useState({})
  const [uploadNewPhotos, setUploadNewPhotos] = useState([])
  const [errors, setErrors] = useState()

  useEffect(() => {
    if (roomPhotoApprovedToDB) {
      setPresavePage((prev) => ({
        ...prev,
        photos: roomPhotoApprovedToDB,
      }))
    }
  }, [roomPhotoApprovedToDB])


  const photosLength = useMemo(() => {
    return presavePage?.photos && presavePage?.photos?.length + uploadNewPhotos?.length;

  }, [presavePage, uploadNewPhotos])


  useEffect(() => {
    if (!typesList) {
      getTypeList()
    }
  }, [getTypeList, typesList])


  useEffect(() => {
    toggleUnsavedPhotos(false);
    toggleUnsavedMainInfo(false);
    setUploadNewPhotos([]);
    if (roomId === "new") {
      clearRoom()
    }

    if ((roomIdByProps !== roomId) && (roomId !== "new")) {
      clearRoom()
      getRoomById({ room: roomId })
      window.scrollTo(0, 0)
    }

  }, [clearRoom, getRoomById, roomId, roomIdByProps])


  const handleChangeRoomMain = (values, form) => {
    toggleUnsavedMainInfo(true)
    setPresavePage(prev => {
      return { ...prev, mainInfo: values }
    })

    if (values.type && values.count && values.adult) {
      setErrors((prev) => {
        return { ...prev, mainInfo: undefined }
      })
    }

  }

  const changeDirtyRoomMain = () => {
    let presavePageCopy = { ...presavePage }
    delete presavePageCopy.mainInfo

    setPresavePage(presavePageCopy)
    if (Object.keys(presavePageCopy).length === 0) {
      toggleUnsavedMainInfo(false)
    }
  }

  /**
   * Изменения загруженных фот
   */
  const handleChangeUploadPhoto = (photos) => {
    let allUploadNewPhotos = [...photos]

    if (presavePage?.deletedPhotos?.length !== 0) {
      allUploadNewPhotos = allUploadNewPhotos.filter((item) => !presavePage?.deletedPhotos?.some((deletedPhoto) => deletedPhoto.includes(item.name)))
    }
    setUploadNewPhotos(() => allUploadNewPhotos)
    toggleUnsavedPhotos(true)
  }
  /**
   * Изменения фот
   */
  const handleChangePhoto = (photos) => {
    const filtredPhotos = photos.map((item) => {
      let copyItem = { ...item }
      if (presavePage?.deletedPhotos?.includes(String(item.id))) {
        return null
      }
      if (item?.id?.split('-')[0] === 'new') {
        delete copyItem['src']
      }
      return copyItem
    }).filter((item) => !!item)

    setPresavePage(prev => {
      return {
        ...prev,
        photos: filtredPhotos,
        deletedPhotos: prev?.deletedPhotos?.filter((photoName) => photoName?.includes('new'))
      }
    })

    toggleUnsavedPhotos(true)
  }


  const handleChangeDeletedPhoto = (deletedPhotos) => {
    const allDeleted = presavePage?.deletedPhotos ? [...presavePage?.deletedPhotos, ...deletedPhotos] : [...deletedPhotos];
    let allUploadNewPhotos = [...uploadNewPhotos]

    if (allDeleted?.length !== 0) {
      allUploadNewPhotos = allUploadNewPhotos.filter((item) => !allDeleted?.some((deletedPhoto) => deletedPhoto.includes(item.name)))
    }
    setUploadNewPhotos(() => allUploadNewPhotos)

    setPresavePage((prev) => ({
      ...prev,
      deletedPhotos: allDeleted,
    }))

    toggleUnsavedPhotos(true)
  }


  const validatePage = async () => {
    await objectAboutMainRef.current.validateForm()

    objectAboutMainRef.current.setFieldTouched("type")
    objectAboutMainRef.current.setFieldTouched("count")
    objectAboutMainRef.current.setFieldTouched("adult")
    objectAboutMainRef.current.setFieldTouched("area")

    let mainInfo = objectAboutMainRef.current.isValid

    if (!mainInfo) {
      window.scrollTo(0, 0)
      setErrors((prev) => {
        return { ...prev, mainInfo: "Обязательные поля не заполнены" }
      })
      return false
    }

    return true

  };


  //сохранение страницы
  const savePageHandler = async () => {
    if (unsavedPhotos || unsavedMainInfo) {
      let valid = await validatePage()

      if (valid) {
        let response = null
        toggleUnsavedPhotos(false)
        toggleUnsavedMainInfo(false)


        let formData = new FormData()


        formData.append(`object`, objectId)
        formData.append(`country`, country)

        uploadNewPhotos.forEach((file, i) => {
          formData.append(`uploadPhotos[${i}]`, file, file.name)
        })
        if (roomId === "new") {
          let t = {
            ...presavePage?.mainInfo,
            ...presavePage?.inRoom,
            photos: presavePage?.photos
          }
          formData.append(`fields`, JSON.stringify(t))
          response = await addRoom(formData)
        } else {
          let t = {}
          if (presavePage.hasOwnProperty("mainInfo")) {
            t = {
              ...presavePage?.mainInfo,
              ...presavePage?.inRoom,
              photos: presavePage?.photos
            }
          } else {
            t = {
              ...roomMain,
              ...presavePage?.inRoom,
              photos: presavePage?.photos
            }
          }
          formData.append(`fields`, JSON.stringify(t))
          formData.append(`room`, roomId)
          response = await updateRoom(formData)
        }
        setPresavePage(null)

        if (response) {
          getRoomsList({ object: objectId })
          setErrors(prev => {
            return { ...prev, photoSize: null }
          })
          if (response.errors || response.payload?.errors) {
            setErrors(prev => {
              return { ...prev, dontUploadPhotos: response.errors || response.payload?.errors }
            });
            if (roomId === "new") {
              history.replace(history.location.pathname + `?room=${response.id}`);
            }
          } else {
            if (targetRedirectLink) {
              history.push(targetRedirectLink)
            }
            goPage("rooms")
          }
          setUploadNewPhotos([])
        }
      }
    } else {
      goPage("rooms")
    }
  };


  const setSizeAlert = () => {
    setErrors((prev) => {
      return {
        ...prev,
        photoSize: "Вы пытаетесь загрузить большие фотографии (больше 2 МБ), По этой причине процесс загрузки может занять больше времени. Если у Вас слабое интернет-соединение, рекомендуем уменьшить фотографии"
      }
    })
  }

  const cancelCreateRoom = () => {
    history.replace(history.location.pathname)
    goPage("rooms")
  }

  const buttons = themeButtons();
  let disableSubmit = roomId == 'new' ? (!unsavedPhotos || !unsavedMainInfo || photosLength < 3) : (photosLength < 3);
  return (
    <div className="stepByStepWrp">
      <div className="stepByStepWrp__header">
        <Typography variant="h5" component="h5" className="stepByStepWrp__title">Добавление номера</Typography>
      </div>
      <div className="stepByStepWrp__body">
        <RenderRoomAboutMain {...roomMain} typesList={typesList} roomId={roomId}
                             handleChangeRoomMain={handleChangeRoomMain}
                             changeDirtyRoomMain={changeDirtyRoomMain}
                             setSizeAlert={setSizeAlert} objectAboutMainRef={objectAboutMainRef}/>

        {errors && errors.dontUploadPhotos && errors.dontUploadPhotos.map((error, i) => {
          return <div key={error.message} className="alert alert-danger alert-dismiss">
            <div className="">
              <div>{error.message}</div>
              {error.items && <ol>
                {error.items.map(item => <li key={item}>{item}</li>)}
              </ol>}

            </div>

            <IconButton
              onClick={() => setErrors((prev) => {
                let newDontUpload = prev.dontUploadPhotos.filter(item => item.message !== error.message)
                return { ...prev, dontUploadPhotos: newDontUpload }
              })}
              className="alert-dismiss__btn">
              <CloseRoundedIcon/>
            </IconButton>
          </div>

        })}
        <RoomPhotoContainer handleChangeUploadPhoto={handleChangeUploadPhoto}
                            handleChangePhoto={handleChangePhoto}
                            handleChangeDeletedPhoto={handleChangeDeletedPhoto}
                            roomPhotoApprovedToDB={roomPhotoApprovedToDB}
                            errors={errors}
                            setSizeAlert={setSizeAlert}/>


      </div>


      <div className="stepByStepWrp__actions">
        <Button className={`btn`} onClick={cancelCreateRoom}>Назад</Button>
        <Button className={`btn ${buttons.btnGreen}`} disabled={disableSubmit}
                onClick={savePageHandler}>{roomId === "new" ? "Добавить" : "Сохранить изменения"}</Button>
      </div>
    </div>
  )
});


export default FastRoomEdit;
